import React from 'react';

import classNames from 'classnames';

import { getClassNamesBySize, MAX_NOTIF, variantsClassNames } from './utils';

import type { BadgeSizes, BadgeVariant } from './types';

export type Props = {
  className?: string;
  variant?: BadgeVariant;
  size?: BadgeSizes;
  value: number;
};

export const Badge: React.FC<Props> = ({ className, size = 'md', variant = 'light', value }) => (
  <div
    data-testid="badge"
    className={classNames(
      className,
      'font-normal!',
      'rounded-full flex items-center justify-center shrink-0',
      variantsClassNames[variant],
      getClassNamesBySize(value)[size],
    )}
  >
    {size !== 'xs' ? (
      <div
        className={classNames({
          'text-b3': size === 'md',
          'text-sm': size === 'sm',
        })}
      >
        {value > MAX_NOTIF ? '99+' : value}
      </div>
    ) : null}
  </div>
);
